import React from 'react';
import { ZapIcon, ClipboardListIcon, PuzzleIcon, RefreshCwIcon, FolderOpenIcon, TimerIcon } from 'lucide-react';
import { benefits } from '../data/content';
const icons = [{
  Icon: ZapIcon,
  color: 'text-amber-600'
}, {
  Icon: ClipboardListIcon,
  color: 'text-sky-600'
}, {
  Icon: PuzzleIcon,
  color: 'text-green-600'
}, {
  Icon: RefreshCwIcon,
  color: 'text-sky-600'
}, {
  Icon: FolderOpenIcon,
  color: 'text-amber-700'
}, {
  Icon: TimerIcon,
  color: 'text-blue-950'
}];
export function BenefitsGrid() {
  return <section className="bg-slate-50 px-4 py-7 text-center md:px-12" data-id="element-1" data-mp="ex1ygrkwsizt">
      <h2 className="mx-auto max-w-2xl text-xl font-extrabold uppercase leading-tight tracking-tight text-blue-950 md:text-2xl" data-id="element-2" data-mp="9y7g1qquswg8">
        Esto no es otro manual lleno de teoría.
      </h2>
      <p className="mx-auto mt-1.5 max-w-2xl text-sm font-bold uppercase leading-tight text-sky-600 md:text-base" data-id="element-3" data-mp="b8ta11elne">
        Es un sistema práctico de consulta para electricistas domiciliarios.
      </p>
      <div className="mt-4 grid gap-2 text-left sm:grid-cols-2" data-id="element-4" data-mp="26rpkm789voc8">
        {benefits.map((b, i) => {
        const {
          Icon,
          color
        } = icons[i];
        return <article key={b.title} className="flex gap-2.5 rounded-md border border-slate-200 bg-white p-3" data-id="element-5" data-mp="2bk8yl5avglhk" data-mpi={i}>
              <Icon className={`mt-0.5 h-[18px] w-[18px] shrink-0 ${color}`} strokeWidth={2.5} aria-hidden data-id="element-6" data-mp="1wrf9cs5ssqzp" />
              <div data-id="element-7" data-mp="2phxjgd4xvsmm">
                <h3 className="text-sm font-bold leading-tight text-blue-950 md:text-base" data-id="element-8" data-mp="2phfi523f6o7u">{b.title}</h3>
                <p className="mt-1 text-sm leading-snug text-slate-600" data-id="element-9" data-mp="2uha5wwrwexoo">{b.text}</p>
              </div>
            </article>;
      })}
      </div>
    </section>;
}